module.exports = __webpack_public_path__ + "img/TECMOUSSE.e5a0623a.png";